module.exports = __webpack_public_path__ + "img/icon_transport_active.4ab68939.svg";